class SearchContentToggle extends window.BAO.CustomElement {
  setupListeners () {
    super.setupListeners()

    if (this.els.tab?.exists) {
      this.els.tab.elements.forEach(tab => {
        tab.addEventListener('click', this.onTabClick.bind(this))
      })
    }

    if (this.externalEls.searchDropdownTrigger?.exists) {
      this.externalEls.searchDropdownTrigger.elements.forEach(button => {
        button.addEventListener('click', this.onSearchOpen.bind(this))
      })
    }

    if (this.externalEls.searchDropdownTriggerMobile?.exists) {
      const input = this.externalEls.searchDropdownTriggerMobile.elements[0]
      input.addEventListener('focus', this.onSearchOpen.bind(this))
    }

    if (this.externalEls.searchDropdownTriggerMobile?.exists) {
      const input = this.externalEls.searchDropdownTriggerMobile.elements[0]
      input.addEventListener('blur', this.onSearchClose.bind(this))
    }

    if (this.els.close?.exists) {
      const close = this.els.close.elements[0]
      close.addEventListener('click', this.onSearchClose.bind(this))
    }

    if (this.externalEls.close?.exists) {
      this.externalEls.close.elements.forEach(close => {
        close.addEventListener('click', this.onSearchClose.bind(this))
      })
    }

    if (this.externalEls.menuOpenCloseSearch?.exists) {
      this.externalEls.menuOpenCloseSearch.elements.forEach(close => {
        close.addEventListener('click', this.onSearchClose.bind(this))
      })
    }

    if (this.externalEls.header?.exists) {
      this.externalEls.header.elements.forEach(header => {
        header.addEventListener('mouseleave', this.onSearchClose.bind(this))
      })
    }

    if (this.externalEls.linklistItem?.exists) {
      this.externalEls.linklistItem.elements.forEach(link => {
        link.addEventListener(
          'mouseenter',
          this.onLinkItemSearchClose.bind(this)
        )
      })
    }
  }

  onTabClick (event) {
    const tabContent = event.target.getAttribute('data-trigger-for')

    const content = this.querySelector(`[data-target-for="${tabContent}"]`)

    this.els.tab.elements.forEach(tab => {
      if (tab === event.target) {
        tab.classList.add('hd-SearchDropdown_NavigationLink-active')
      } else {
        tab.classList.remove('hd-SearchDropdown_NavigationLink-active')
      }
    })

    this.els.content.elements.forEach(contentElement => {
      if (contentElement === content) {
        contentElement.setAttribute('aria-hidden', 'false')
      } else {
        contentElement.setAttribute('aria-hidden', 'true')
      }
    })

    window.BAO.dispatchEvent(window.BAO.EVENTS.SEARCH_TAB.SWAPPED)
  }

  onSearchOpen (event) {
    document.body.classList.add('util-SiteOverflowed', 'util-SearchOpen')

    if (window.innerWidth < 960) {
      const parentElement = event.target.closest(
        '[data-search-content-toggle-external-el="siteHeader"]'
      )
      const dropdownContainer = parentElement.querySelector(
        '[data-search-content-toggle-external-el="searchDropdownTrigger"]'
      )
      const dropdown = dropdownContainer.querySelector('.hd-Dropdown')

      dropdownContainer
        .querySelector('.hd-Search_Form')
        .classList.add('hd-Search_Form-active')
      dropdown.classList.add('hd-Dropdown-active')
    } else if (window.innerWidth >= 960) {
      const parentElement = event.target.closest(
        '[data-search-content-toggle-external-el="searchDropdownTrigger"]'
      )
      const dropdown = parentElement.querySelector('.hd-Dropdown')

      parentElement
        .querySelector('.hd-Search_Form')
        .classList.add('hd-Search_Form-active')
      dropdown.classList.add('hd-Dropdown-active')

      parentElement
        .querySelector('.hd-Search_Form')
        .querySelector('.hd-Search_Input')
        .focus()
    }

    window.BAO.dispatchEvent(window.BAO.EVENTS.SEARCH_TAB.OPENED)
  }

  onLinkItemSearchClose (event) {
    const parentElement = event.target
      .closest('[data-search-content-toggle-external-el="header"]')
      .querySelector(
        '[data-search-content-toggle-external-el="searchDropdownTrigger"]'
      )
    const dropdown = parentElement.querySelector('.hd-Dropdown')

    setTimeout(() => {
      document.body.classList.remove('util-SiteOverflowed', 'util-SearchOpen')
      parentElement
        .querySelector('.hd-Search_Form')
        .classList.remove('hd-Search_Form-active')
      parentElement
        .querySelector('.hd-Search_Form')
        .querySelector('.hd-Search_Input')
        .blur()
      dropdown.classList.remove('hd-Dropdown-active')
    }, 10)
  }

  onSearchClose (event) {
    if (
      event.target.closest(
        '[data-search-content-toggle-external-el="menuOpenCloseSearch"]'
      )
    ) {
      const closeElement = event.target.closest(
        '[data-search-content-toggle-external-el="menuOpenCloseSearch"]'
      )
      const siteHeader = closeElement.closest(
        '[data-search-content-toggle-external-el="siteHeader"]'
      )
      const dropdownTrigger = siteHeader.querySelector(
        '[data-search-content-toggle-external-el="searchDropdownTrigger"]'
      )
      const close = dropdownTrigger.querySelector(
        '[data-search-content-toggle-el="close"]'
      )

      close.click()
    } else if (
      event.target.hasAttribute('data-search-content-toggle-el') &&
      event.target.getAttribute('data-search-content-toggle-el') === 'close'
    ) {
      const parentElement = event.target.closest(
        '[data-search-content-toggle-external-el="searchDropdownTrigger"]'
      )
      const dropdown = parentElement.querySelector('.hd-Dropdown')

      setTimeout(() => {
        document.body.classList.remove('util-SiteOverflowed', 'util-SearchOpen')
        parentElement
          .querySelector('.hd-Search_Form')
          .classList.remove('hd-Search_Form-active')
        parentElement
          .querySelector('.hd-Search_Form')
          .querySelector('.hd-Search_Input')
          .blur()
        dropdown.classList.remove('hd-Dropdown-active')
      }, 10)
    } else if (
      event.target.hasAttribute('data-search-content-toggle-external-el') &&
      event.target.getAttribute('data-search-content-toggle-external-el') ===
        'header'
    ) {
      const parentElement = event.target.querySelector(
        '[data-search-content-toggle-external-el="searchDropdownTrigger"]'
      )
      const dropdown = parentElement.querySelector('.hd-Dropdown')

      setTimeout(() => {
        document.body.classList.remove('util-SiteOverflowed', 'util-SearchOpen')
        parentElement
          .querySelector('.hd-Search_Form')
          .classList.remove('hd-Search_Form-active')
        parentElement
          .querySelector('.hd-Search_Form')
          .classList.remove('hd-Search_Form-active')
        parentElement
          .querySelector('.hd-Search_Form')
          .querySelector('.hd-Search_Input')
          .blur()
        dropdown.classList.remove('hd-Dropdown-active')
      }, 10)
    }
  }
}
if (!customElements.get('search-content-toggle')) {
  customElements.define('search-content-toggle', SearchContentToggle)
}
